<template>
  <BreadCrumb />
  <div v-if="loading" class="loading">
    <h4>Loading data</h4>
  </div>
  <div v-else>
    <div class="plant-base plant-description">
      <div v-if="foundPlants.length === 1">
        <div>{{ foundPlants.length }} plant has been found</div>
      </div>
      <div v-else>
        <div>{{ foundPlants.length }} plants have been found</div>
      </div>
    </div>
    <div v-if="foundPlants.length > 0">
      <div class="category">
        <CardPlant
          v-for="plant in foundPlants"
          :plant="plant"
          :key="plant.id"
          isSmall="true"
        />
      </div>
    </div>
    <div v-else><NoData /></div>
  </div>
</template>
<script>
import CardPlant from "../Cards/CardPlant.vue";
import NoData from "../NoData/NoData.vue";
import BreadCrumb from "../BreadCrumb/BreadCrumb.vue";

import PlantService from "@/services/PlantService.js";
import { useRoute } from "vue-router";
export default {
  name: "SearchPage",
  components: {
    CardPlant,
    NoData,
    BreadCrumb,
  },
  data() {
    return {
      plants: [],
      loading: false,
    };
  },
  methods: {
    async fetchDataPlants(textSearch) {
      this.loading = true;
      PlantService.searchPlant(textSearch)
        .then((res) => {
          this.foundPlants = res;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.$watch(
      () => this.$route.query,
      (toQuery) => {
        this.fetchDataPlants(toQuery.textSearch);
      }
    );
  },
  created() {
    const route = useRoute();
    const textSearch = route.query.textSearch;
    this.fetchDataPlants(textSearch);
  },
};
</script>
<style lang="scss" scoped>
.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.plant-base {
  width: 100%;
  border-radius: 0.8rem;
  margin-top: 1rem;
  padding: 2rem;
  box-sizing: border-box;
}

.plant-description {
  background-color: #eeeeee;
  margin-bottom: 1rem;
}
.content-home-title {
  font-weight: 700;
  font-size: 2rem;
  margin-bottom: 1rem;
}
.content-subtitle {
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 32px;
}
.container {
  width: 60rem;
  margin-left: auto;
  margin-right: auto;
}
.category {
  gap: 5px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  width: 100%;
  @media (min-width: $constraint-width-small) {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  }
  @media (min-width: $breakpoint-small) {
    grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  }
  @media (min-width: $constraint-width-x-medium) {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  }
  @media (min-width: $constraint-width-medium) {
    grid-template-columns: repeat(auto-fill, minmax(215px, 1fr));
  }
  @media (min-width: $breakpoint-large) {
    grid-template-columns: repeat(4, minmax(220px, 1fr));
  }
  @media (min-width: $constraint-width-x-large) {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  }
}
</style>
